const imgExtensionsList = [
    'jpg', 'jpeg', 'png', 'gif'
  ]

export default imgExtensionsList